import { infos_to_display } from "../settings";

export const Title = ({ image }) => {

  if (!image.exifs.title || !infos_to_display.title) {
    return null;
  }

  return (
    <h2 dangerouslySetInnerHTML={{__html: image.exifs.title}} />
  );
};
